import {
  MeetingsMeetingProviderDocument,
  MeetingsMeetingProviderItemFragment,
  MeetingsMeetingProviderItemPageFragment,
} from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

interface UseMeetingDataReturn {
  meeting: MeetingsMeetingProviderItemFragment | null
  page: MeetingsMeetingProviderItemPageFragment | null
  notes: string | null
  loading: boolean
  error: string | null
}

interface UseMeetingDataParams {
  meetingId: number | null
}

export const useMeetingData = ({ meetingId }: UseMeetingDataParams): UseMeetingDataReturn => {
  const { employee: currentEmployee } = useCurrentSession()

  const { data, loading, error, networkActivity } = useQuery(MeetingsMeetingProviderDocument, {
    variables: {
      meetingId: Number(meetingId),
    },
    skip: !meetingId,
  })

  const meeting = data?.meetings?.meeting ?? null
  const meetingNotFound = data?.meetings?.meeting === null && !loading

  // Derive page and notes directly from state
  const pageRaw = meeting?.attendees.find(
    (attendee) => attendee.employee?.id === currentEmployee?.id
  )?.page

  // Derive values directly without an intermediary function
  const page = pageRaw
    ? {
        id: pageRaw.id,
        title: pageRaw.title,
        updatedAt: pageRaw.updatedAt,
      }
    : null

  const notes = pageRaw?.content ?? null

  return {
    meeting,
    page,
    notes,
    loading: loading || networkActivity,
    error: error?.message ?? (meetingNotFound ? 'Meeting not found' : null),
  }
}
